import { Link } from "react-router-dom";
import { comics, hotKeywords, hotRanking } from "@/mocks/comics";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-400",
  down: "ri-arrow-down-line text-foreground-600",
  flat: "ri-arrow-right-line text-foreground-700",
};

export default function RankingSection() {
  const top = hotRanking.slice(0, 5);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col md:flex-row gap-8 md:gap-10">
        {/* 热搜词 */}
        <div className="md:w-1/3">
          <div className="flex items-center gap-3 mb-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-fire-line text-xl"></i>
            </span>
            <div>
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950">今日热搜词</h2>
              <p className="text-xs text-foreground-600">大家都在找什么爽漫</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2.5">
            {hotKeywords.map((k, i) => (
              <Link
                key={k}
                to={`/recommend?q=${encodeURIComponent(k)}`}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  i < 3
                    ? "bg-primary-500/15 text-primary-400 border border-primary-500/30 hover:bg-primary-500/25"
                    : "bg-background-100 text-foreground-600 border border-background-300/50 hover:text-primary-400"
                }`}
              >
                {i < 3 && <i className="ri-fire-fill text-xs"></i>}
                {k}
              </Link>
            ))}
          </div>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600">
            热搜词由近 7 天用户搜索与阅读热度综合生成，帮助你快速找到当下最火的
            <strong className="text-foreground-950">开挂主角漫画</strong>与
            <strong className="text-foreground-950">打脸爽文漫</strong>，点一下直达对应内容。
          </p>
        </div>

        {/* 热血战斗 TOP5 */}
        <div className="md:w-2/3">
          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-medal-line text-xl"></i>
              </span>
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950">热血战斗排行</h2>
                <p className="text-xs text-foreground-600">今日人气最高的战斗爽漫 TOP 5</p>
              </div>
            </div>
            <Link to="/ranking" className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              查看完整榜单<i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="flex flex-col gap-3">
            {top.map((item) => {
              const c = comics.find((x) => x.id === item.comicId)!;
              return (
                <li key={item.rank}>
                  <Link
                    to={`/comic/${c.id}`}
                    className="group flex items-center gap-3 md:gap-4 rounded-lg bg-background-100 border border-background-300/50 p-3 hover:border-primary-500/50 transition-colors"
                  >
                    <span
                      className={`flex h-9 w-9 md:h-10 md:w-10 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                        item.rank === 1
                          ? "bg-accent-500 text-background-50"
                          : item.rank <= 3
                          ? "bg-primary-500/20 text-primary-400"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <img
                      src={c.cover}
                      alt={`${c.title}封面`}
                      className="h-14 w-10 md:h-16 md:w-11 shrink-0 rounded-md object-cover object-top"
                    />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <h3 className="font-heading text-base md:text-lg text-foreground-950 truncate group-hover:text-primary-400 transition-colors">{c.title}</h3>
                        <span className="hidden md:inline-flex items-center gap-0.5 text-accent-400 text-sm shrink-0">
                          <i className="ri-star-fill text-xs"></i>{c.rating.toFixed(1)}
                        </span>
                      </div>
                      <p className="mt-0.5 text-xs text-foreground-600 truncate">{c.desc}</p>
                    </div>
                    <span className="hidden sm:flex items-center gap-1 text-xs text-foreground-600 shrink-0">
                      <i className={trendIcon[item.trend]}></i>
                    </span>
                    <span className="shrink-0 text-xs text-foreground-700 whitespace-nowrap">{c.hot >= 10000 ? `${(c.hot / 10000).toFixed(1)}w` : c.hot}热度</span>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}